<template>
    <section>
        <navigation></navigation>
        <h5 class="center-align">Merchants</h5>

        <div class="row">
            <div class="input-field col s12">
                <input id="filter_user_field" type="text" class="validate" v-model="search">
                <label for="filter_user_field">Search by Company Name, Owner Name, Business Address, Email or Phone Number</label>
            </div>
            <div class="col s12">
                <table>
                    <thead>
                        <tr>
                            <th></th>
                            <th>Company Name</th>
                            <th>Business Address</th>
                            <th>Owner Name</th>
                            <th>Email</th>
                            <th>Phone Number</th>
                            <th>SEC/DTI Registration No</th>
                            <th>TIN Number</th> 
                        </tr>
                    </thead>
                    <tbody class="striped" id="listOfLogs" v-for="todo in filteredItems"  :key="todo.id">
                        <tr>
                            <td>
                                 <img
                                        :src="todo.imageLogo"
                                        style="width:50px;height:50px;border-radius:50%;border:2px solid #333"
                                    />
                            </td>
                            <td>{{todo.companyName}}</td>
                            <td>{{todo.businessAddress}}</td>
                            <td>{{todo.fullName}}</td>
                            <td>{{todo.email}}</td>
                            <td>{{todo.phoneNumber}}</td>
                            <td>{{todo.secDtiRegistration}}</td>
                            <td>{{todo.tinNumber}}</td>
                        </tr>
                    </tbody>

                </table>
            </div>
        </div>


        <!-- <ul class="collection with-header">
            <li
                class="collection-item"
                v-for="todo in todos"
                :key="todo.id"
                :class="{ fade: todo.activated }"
            >
                <span class="deleteIcon" @click="deleteToDo(todo.id)">&#10005;</span>
                {{todo.name}}
                <span class="secondary-content">
                    <label>
                        <input
                            type="checkbox"
                            class="filled-in"
                            :checked="todo.activated"
                            @change="updateTodoItem(todo.id, $event)"
                        />
                        <span></span>
                    </label>
                </span>
            </li>
        </ul> -->
    </section>
</template>

<script>
import navigation from "@/components/NavBar.vue";
import firebase from "firebase";

export default {
    data() {
        return {
            search: '',
            todos: [],
            todo: {
                title: ""
            }
        };
    },
    created() {
        this.getTodos();
    },
    computed: {
        filteredItems() {
            return this.todos.filter(todo => {
                return (todo.companyName.toLowerCase().indexOf(this.search.toLowerCase()) > -1) ||
                (todo.businessAddress.toLowerCase().indexOf(this.search.toLowerCase()) > -1) ||
                (todo.fullName.toLowerCase().indexOf(this.search.toLowerCase()) > -1) ||
                (todo.email.toLowerCase().indexOf(this.search.toLowerCase()) > -1) ||
                (todo.phoneNumber.toLowerCase().indexOf(this.search.toLowerCase()) > -1) ||
                (todo.secDtiRegistration.toLowerCase().indexOf(this.search.toLowerCase()) > -1) ||
                (todo.tinNumber.toLowerCase().indexOf(this.search.toLowerCase()) > -1) 
            })
        }
    },
    components: { navigation },
    methods: {
        addTodo() {
            firebase
                .firestore()
                .collection("merchants")
                .add({
                    title: this.todo.title,
                    createdAt: new Date(),
                    isCompleted: false
                });
        },
        async getTodos() {
            var todosRef = await firebase
                .firestore()
                .collection("merchants")
            todosRef.onSnapshot(snap => {
                this.todos = [];
                snap.forEach(doc => {
                    var todo = doc.data();
                    todo.id = doc.id;
                    this.todos.push(todo);
                });
            });
        },
        updateTodoItem(docId, e) {
            var isChecked = e.target.checked;
            firebase
                .firestore()
                .collection("merchants")
                .doc(docId)
                .update({
                    activated: isChecked
                });
        },
        convertBooleanToWord(str){
            if(str){
                return "Enabled";
            }
            else{
                return "Disabled";
            }
        },
        updateTodoItem2(docId, e) {
            firebase
                .firestore()
                .collection("users")
                .doc(docId)
                .update({
                    isActivated: e
                });
        },
        deleteToDo(docId) {
            firebase
                .firestore()
                .collection("users")
                .doc(docId)
                .delete();
        }
    }
};
</script>

<style>
.fade {
    opacity: 0.4 !important;
}
li {
    font-size: 1.3em;
}
.collection.with-header {
    max-width: 500px;
    margin: 0 auto;
}
.deleteIcon {
    margin-right: 10px;
    cursor: pointer;
}
.deleteIcon:hover {
    opacity: 0.5;
}
</style>

